import {
  CREATE_PROGRAM,
  GET_PROGRAMS,
  GET_PROGRAM_DETAILS,
  GET_PROGRAM_INFO,
  GET_PROGRAM_STATUS,
  GET_TOP_PROGRAMS,
  REVIEW_PROGRAM,
  REVIEW_PROGRAM_TO_EMPLOYEE,
  GET_CREDIT_TRANSACTIONS_FOR_PROGRAM,
  GET_EMPLOYEES_FOR_PROGRAM,
  GET_PAYMENTS_FOR_PROGRAM,
  ADD_OPTION,
  UPDATE_OPTION,
  UPDATE_OPTION_STATUS,
  CLEAR_PROGRAM_INFO,
} from '../../actions/programs';

const programsReducer = (state = {}, action = {}) => {
  const {
    type = '',
    newProgram = {},
    programsData = {},
    programData = {},
    programInfo = {},
    topPrograms = {},
    programStatus = 1,
    reviewProgramDetails = {},
    reviewProgramMapping = {},
    programEmployees = {},
    programPayments = {},
    programCreditTransactions = {},
  } = action;

  switch (type) {
    case CREATE_PROGRAM.INITIATE: {
      return {
        ...state,
      };
    }
    case CREATE_PROGRAM.SUCCESS: {
      const { programId = 0, response = {} } = newProgram;

      return {
        ...state,
        programId,
        response,
      };
    }
    case CREATE_PROGRAM.FAILED:
      return {
        ...state,
      };

    case REVIEW_PROGRAM.SUCCESS: {
      return {
        ...state,
        reviewProgramDetails,
      };
    }
    case REVIEW_PROGRAM.FAILED: {
      return {
        ...state,
      };
    }
    case REVIEW_PROGRAM.INITIATE: {
      return {
        ...state,
      };
    }
    case GET_PROGRAMS.INITIATE:
      return {
        ...state,
      };
    case GET_PROGRAMS.SUCCESS:
      return {
        ...state,
        ...programsData,
      };
    case GET_PROGRAMS.FAILED:
      return {
        ...state,
      };
    case GET_TOP_PROGRAMS.INITIATE:
      return {
        ...state,
      };
    case GET_TOP_PROGRAMS.SUCCESS:
      return {
        ...state,
        topPrograms: { ...topPrograms },
      };
    case GET_TOP_PROGRAMS.FAILED:
      return {
        ...state,
      };
    case GET_PROGRAM_DETAILS.INITIATE: {
      return {
        ...state,
      };
    }
    case GET_PROGRAM_DETAILS.SUCCESS:
      return {
        ...state,
        programData,
      };
    case GET_PROGRAM_DETAILS.FAILED:
      return {
        ...state,
      };
    case GET_PROGRAM_INFO.INITIATE: {
      return {
        ...state,
      };
    }
    case GET_PROGRAM_INFO.SUCCESS:
      return {
        ...state,
        programInfo,
      };
    case GET_PROGRAM_INFO.FAILED:
      return {
        ...state,
      };
    case REVIEW_PROGRAM_TO_EMPLOYEE.SUCCESS: {
      return {
        ...state,
        reviewProgramMapping,
      };
    }
    case REVIEW_PROGRAM_TO_EMPLOYEE.FAILED: {
      return {
        ...state,
      };
    }
    case REVIEW_PROGRAM_TO_EMPLOYEE.INITIATE: {
      return {
        ...state,
      };
    }
    case GET_PROGRAM_STATUS.INITIATE: {
      return {
        ...state,
      };
    }
    case GET_EMPLOYEES_FOR_PROGRAM.INITIATE:
      return {
        ...state,
      };
    case GET_EMPLOYEES_FOR_PROGRAM.SUCCESS:
      return {
        ...state,
        programEmployees,
      };
    case GET_EMPLOYEES_FOR_PROGRAM.FAILED:
      return {
        ...state,
      };
    case GET_PAYMENTS_FOR_PROGRAM.INITIATE:
      return {
        ...state,
      };
    case GET_PAYMENTS_FOR_PROGRAM.SUCCESS:
      return {
        ...state,
        programPayments,
      };
    case GET_PAYMENTS_FOR_PROGRAM.FAILED:
      return {
        ...state,
      };
    case GET_CREDIT_TRANSACTIONS_FOR_PROGRAM.INITIATE:
      return {
        ...state,
      };
    case GET_CREDIT_TRANSACTIONS_FOR_PROGRAM.SUCCESS:
      return {
        ...state,
        programCreditTransactions,
      };
    case GET_CREDIT_TRANSACTIONS_FOR_PROGRAM.FAILED:
      return {
        ...state,
      };
    case GET_PROGRAM_STATUS.SUCCESS: {
      const updatedState = state;
      updatedState.programInfo.status = programStatus;
      return {
        ...updatedState,
      };
    }
    case GET_PROGRAM_STATUS.FAILED:
      return {
        ...state,
      };
    case ADD_OPTION.INITIATE:
    case ADD_OPTION.SUCCESS:
    case ADD_OPTION.FAILED:
    case UPDATE_OPTION.INITIATE:
    case UPDATE_OPTION.SUCCESS:
    case UPDATE_OPTION.FAILED:
    case UPDATE_OPTION_STATUS.INITIATE:
    case UPDATE_OPTION_STATUS.SUCCESS:
    case UPDATE_OPTION_STATUS.FAILED:
      return {
        ...state,
      };
    case CLEAR_PROGRAM_INFO:
      return {
        ...state,
        programInfo: {},
        reviewProgramDetails: {},
      };
    default:
      return state;
  }
};

export default programsReducer;
